module.exports = __webpack_public_path__ + "img/no-data.df38915f.png";